"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSchemaKeys;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function getAllFieldsOfContents(contents) {
  return Object.keys(contents).reduce(function (options, key) {
    var childContents = contents[key].contents;
    var contentsObject = Array.isArray(childContents) ? childContents[0].contents : childContents;
    if (contentsObject) {
      return options.concat(getAllFieldsOfContents(contentsObject).map(function (v) {
        return Array.isArray(childContents) ? [key, 0].concat(_toConsumableArray(v)) : [key].concat(_toConsumableArray(v));
      }));
    }
    return options.concat([[key]]);
  }, []);
}

function getSchemaKeys(schema, flatSimpleKey) {
  var contents = schema.contents;

  var keys = getAllFieldsOfContents(contents);
  return flatSimpleKey ? keys.map(function (v) {
    return v.length === 1 ? v[0] : v;
  }) : keys;
}


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/schema/getSchemaKeys.js
// module id = 1296
// module chunks = 0